import { Empty } from 'antd'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import DatePicker from 'components/DatePickerStyles/DatePicker/index'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import TextAreas from 'components/Form/TextArea'
import Camera from 'components/icons/Camera'
import ErrorIcon from 'components/icons/ErrorIcon'
import LinkIcon from 'components/icons/LinkIcon'
import RichEditor from 'components/RichEditor'
import Select from 'components/Select'
import { CopyLinkDiv, FormItem } from 'components/UIComponents/FormStyles'
import Uploader from 'components/Uploader/ImageUploader'
import {
  AddressFlex,
  AlertFlex,
  ButtonCenterPadding,
  ComanyDiv,
  CommonFlex,
  Divider,
  ErrorMsgDiv,
  ImageColPadding,
  ImageFlex,
  ImageSpan,
  ImageTag,
  ImageUploadWrapper,
  MainWrapper,
  RightSection,
  StyledInput,
  StyledInputDiv,
  StyledSelectDiv,
  SubDiv,
  SubTitleDiv,
  TierInputNumber,
} from 'modules/Settings/Components/InstituteInfo/style'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { copyText } from 'utils/copyText'
import { IsValidEmail } from 'utils/emailValidation'
import { getUniversityList } from '../../actions'

const InstituteInfo = ({
  setFile,
  file,
  instituteData,
  getListOfCities,
  getListOfCountries,
  getListOfStates,
  selectedCountry,
  setSelectedCountry,
  selectedState,
  setSelectedState,
  setSelectedCity,
  selectedCity,
  getUserRoles,
  userRoles,
  aboutWarning,
  presentationFile,
  settingsForm,
  onUniversityChange,
  universityList,
}) => {
  const dispatch = useDispatch()

  const [countryList, setCountryList] = useState([])
  const [searchCountry, setSearchCountry] = useState('')
  const [stateList, setStateList] = useState([])
  const [searchState, setSearchState] = useState('')
  const [cityList, setCityList] = useState([])
  const [searchCity, setSearchCity] = useState('')

  useEffect(() => {
    setSearchCountry(instituteData?.country)
    setSearchState(instituteData?.state)
    setSearchCity(instituteData?.city)

    setSelectedCountry({
      _id: instituteData?.countryId,
      name: instituteData?.country,
    })
    setSelectedState({
      _id: instituteData?.stateId,
      name: instituteData?.state,
    })
    setSelectedCity({
      _id: instituteData?.cityId,
      name: instituteData?.city,
    })
    getUserRoles()
  }, [])

  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getCountries()
    }, 500)
    return () => clearTimeout(getData)
  }, [searchCountry])

  const getCountries = async () => {
    const { data, status } = await getListOfCountries({
      searchValue: searchCountry,
    })
    if (status >= 200 && status <= 300) {
      setCountryList(data?.data?.result)
    } else {
      setCountryList([])
    }
  }

  useEffect(() => {
    let getData
    if (selectedCountry && Object?.keys(selectedCountry)?.length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getStates()
        }, 500)
      } else {
        getStates()
      }
    }
    return () => clearTimeout(getData)
  }, [searchState, selectedCountry])

  const getStates = async () => {
    const { data, status } = await getListOfStates({
      searchValue: searchState,
      countryId: selectedCountry?.option?._id,
    })
    if (status >= 200 && status <= 300) {
      setStateList(data?.data?.result)
    } else {
      setStateList([])
    }
  }

  useEffect(() => {
    let getData
    if (Object.keys(selectedState)?.length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getCities()
        }, 500)
      } else {
        getCities()
      }
    }
    return () => clearTimeout(getData)
  }, [searchCity, selectedState])

  const getCities = async () => {
    const { data, status } = await getListOfCities({
      searchValue: searchCity,
      stateId: selectedState?._id,
    })
    if (status >= 200 && status <= 300) {
      setCityList(data?.data?.result)
    } else {
      setCityList([])
    }
  }

  const delayUniversityToFetch = useCallback(
    debounce(data => {
      dispatch(getUniversityList(data))
    }, 500),
    []
  )

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const dateFormat = 'YYYY'
  const CountryCode = [
    {
      name: '91',
      value: '91',
    },
  ]

  const CollegeType = [
    {
      id: '1',
      value: 'Tier 1',
    },
    {
      id: '2',
      value: 'Tier 2',
    },
    {
      id: '3',
      value: 'Tier 3',
    },
    {
      id: '4',
      value: 'Tier 4',
    },
  ]

  return (
    <>
      <MainWrapper>
        <ComanyDiv>Institute Info</ComanyDiv>
        {aboutWarning && !presentationFile?.url ? (
          <AlertFlex>
            <ErrorIcon />
            <ErrorMsgDiv>
              About Institute and additional details is pending.
            </ErrorMsgDiv>
          </AlertFlex>
        ) : aboutWarning ? (
          <AlertFlex>
            <ErrorIcon />
            <ErrorMsgDiv>About Institute is pending.</ErrorMsgDiv>
          </AlertFlex>
        ) : !presentationFile?.url ? (
          <AlertFlex>
            <ErrorIcon />
            <ErrorMsgDiv>Additional details is pending.</ErrorMsgDiv>
          </AlertFlex>
        ) : (
          ''
        )}
        <CommonFlex spaceBetween>
          <SubTitleDiv>Institute Logo</SubTitleDiv>

          <RightSection>
            <ImageFlex row centerVertically>
              <ImageColPadding>
                <ImageUploadWrapper column alignCenter center>
                  {!file && (
                    <Fragment>
                      <Control column alignCenter>
                        <Camera />
                      </Control>
                      <Control column alignCenter top={'3px'}>
                        <Control column alignCenter>
                          Max file size: 2MB
                        </Control>
                        <Control column alignCenter>
                          Dimension: 130*130
                        </Control>
                        <Control column alignCenter>
                          File format: .png, .jpeg
                        </Control>
                      </Control>
                    </Fragment>
                  )}

                  {file && <ImageTag src={file} />}
                </ImageUploadWrapper>

                {!file && (
                  <Uploader
                    setFile={setFile}
                    showTextUploder={!file}
                    fileName={
                      instituteData?.campusName
                        ?.toLowerCase()
                        .replace(/\s/g, '') + '_logo'
                    }
                  />
                )}
              </ImageColPadding>

              <ButtonCenterPadding>
                {file ? (
                  <Flex>
                    <Uploader
                      isDelete={true}
                      file={file}
                      setFile={setFile}
                      showButtonUploder={file}
                      fileName={
                        instituteData?.campusName
                          ?.toLowerCase()
                          .replace(/\s/g, '') + '_logo'
                      }
                    />
                    &nbsp; &nbsp;
                    <Button.Secondary
                      text="Remove"
                      onClick={() => setFile(null)}
                      height={'32px'}
                      width="76px"
                    />
                  </Flex>
                ) : null}
              </ButtonCenterPadding>
            </ImageFlex>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>University Name*</SubTitleDiv>
          <RightSection>
            <Select
              width="100%"
              placeholder="Eg. Pune University"
              name={'universityName'}
              rules={[
                {
                  required: true,
                  message: 'Please select University name',
                },
              ]}
              OptionData={universityList || []}
              valueParam="name"
              nameParam="name"
              showSearch={true}
              onSearch={delayUniversityToFetch}
              onChange={onUniversityChange}
              filterOption={false}
              allowClear={true}
              value={settingsForm.getFieldValue(['universityName'])}
              isKey={true}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Institute Name*</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Institute Name"
              width="100%"
              name="instituteName"
              maxLength={120}
              rules={[
                {
                  min: 3,
                  max: 120,
                  message:
                    'Please enter college name! Minimum 3 characters , Maximum 120 characters',
                },
                {
                  validator(_, value) {
                    if (!value?.trim()) {
                      return Promise.reject(
                        new Error(`Please enter Institute Name`)
                      )
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            />
          </RightSection>
        </CommonFlex>

        <CommonFlex spaceBetween>
          <SubTitleDiv>Website Link*</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Website link"
              name="websiteLink"
              width="100%"
              // type="url"
              suffix={
                <CopyLinkDiv
                  onClick={() =>
                    copyText(settingsForm.getFieldValue('websiteLink'))
                  }
                >
                  <LinkIcon />
                </CopyLinkDiv>
              }
              rules={[
                {
                  required: true,
                  message: 'Please enter website link.',
                },
              ]}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>College Type*</SubTitleDiv>
          <RightSection>
            <FormItem
              name={'college'}
              rules={[
                {
                  required: true,
                  message: 'Please select a College Type',
                },
              ]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select College Type"
                width="100%"
                OptionData={CollegeType}
                nameParam="value"
                valueParam="value"
                notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Number of Students*</SubTitleDiv>
          <RightSection>
            <TierInputNumber
              width="100%"
              name={'numberOfStudents'}
              placeholder="Eg: 200+"
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    if (value === null) {
                      return Promise.reject(
                        new Error('Please enter number of students')
                      )
                    }
                    const intValue = parseInt(value)
                    if (isNaN(intValue) || intValue <= 0) {
                      return Promise.reject(
                        new Error('Please enter valid number greater than 0')
                      )
                    }
                    return Promise.resolve()
                  },
                },
              ]}
              formatter={value => (value > 0 ? `${value}+` : value)}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Established Year</SubTitleDiv>
          <RightSection>
            <DatePicker
              placeholder={dateFormat}
              dateFormat={dateFormat}
              picker="year"
              name="establishedYear"
              disabledDate={d => !d || d.isAfter()}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>
            <Flex centerVertically>
              <SubDiv>One liner*</SubDiv>
              {!!aboutWarning && (
                <ImageSpan>
                  <ErrorIcon />
                </ImageSpan>
              )}
            </Flex>
          </SubTitleDiv>
          <RightSection>
            <TextAreas
              rows={2}
              maxLength={100}
              showCount
              name={'shortDescription'}
              rules={[
                {
                  required: true,
                  message: 'Please add short description about institute',
                },
                {
                  validator: (_, value) => {
                    if (
                      /\s/.test(!value) ||
                      (value?.length >= 1 && value?.trim()?.length === 0)
                    ) {
                      return Promise.reject('Description cannot contain spaces')
                    }
                    {
                      return Promise.resolve()
                    }
                  },
                },
              ]}
              placeholder={'Add short description about institute'}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>
            <Flex centerVertically>
              <SubDiv> About Institute</SubDiv>
              {!!aboutWarning && (
                <ImageSpan>
                  <ErrorIcon />
                </ImageSpan>
              )}
            </Flex>
          </SubTitleDiv>
          <RightSection>
            {instituteData?.longDescription !== undefined && (
              <FormItem
                name="aboutInstitute"
                initialValue={instituteData?.longDescription}
              >
                <RichEditor
                  placeholder="What’s special about your Institute? What are your vision? What are
            the goals? What  Institute is all all about?"
                  labelName={''}
                />
              </FormItem>
            )}
          </RightSection>
        </CommonFlex>
      </MainWrapper>

      <Divider />

      <MainWrapper>
        <ComanyDiv>Location</ComanyDiv>

        <CommonFlex spaceBetween>
          <SubTitleDiv>Address</SubTitleDiv>
          <RightSection>
            <AddressFlex column>
              <Input
                label="Address 1*"
                placeholder="Enter Address"
                width="100%"
                name="addressOne"
                rules={[
                  {
                    required: true,
                    message: 'Please enter address.',
                  },
                ]}
              />
              <Input
                label="Address 2"
                name="addressTwo"
                placeholder="Enter Address"
                width="100%"
              />
            </AddressFlex>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Country*</SubTitleDiv>
          <RightSection>
            <FormItem
              name={'instituteCountry'}
              rules={[{ required: true, message: 'Please select country.' }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select Country"
                width="40%"
                OptionData={countryList}
                nameParam="name"
                valueParam="name"
                onSearch={value => setSearchCountry(value)}
                onChange={(value, option) => {
                  if (option) {
                    setSelectedCountry(option)
                    settingsForm?.setFieldsValue({
                      instituteCountry: option?.name,
                    })
                    settingsForm?.setFieldsValue({ instituteState: '' })
                    settingsForm?.setFieldsValue({ instituteCity: '' })
                  }
                }}
                onClear={() => {
                  setSearchCountry('')
                  setSelectedCountry({})
                  settingsForm?.setFieldsValue({ instituteState: '' })
                  settingsForm?.setFieldsValue({ instituteCity: '' })
                  if (selectedState?._id) {
                    setSearchState('')
                    setSelectedState({})
                    settingsForm?.setFieldsValue({ instituteState: '' })
                  }
                  if (selectedCity?.option?._id) {
                    setSearchCity('')
                    setSelectedCity({})
                    settingsForm?.setFieldsValue({ companyCity: '' })
                  }
                }}
                filterOption={false}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>State*</SubTitleDiv>
          <RightSection>
            <FormItem
              name="instituteState"
              rules={[{ required: true, message: 'Please select a state.' }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select State"
                width="40%"
                OptionData={stateList}
                nameParam="name"
                valueParam="name"
                onSearch={value => setSearchState(value)}
                onChange={(_, { option }) => {
                  setSelectedState(option)
                  settingsForm.setFieldsValue({ instituteState: option?.name })
                  settingsForm.setFieldsValue({ instituteCity: '' })
                }}
                onClear={() => {
                  setSearchState('')
                  setSelectedState({})
                  if (selectedCity?.option?._id) {
                    setSearchCity('')
                    setSelectedCity({})
                    settingsForm.setFieldsValue({ companyCity: '' })
                  }
                }}
                filterOption={false}
                disabled={!selectedCountry?.option?._id}
                notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>City*</SubTitleDiv>
          <RightSection>
            <FormItem
              name="instituteCity"
              rules={[{ required: true, message: 'Please select a city.' }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select City"
                width="40%"
                OptionData={cityList}
                nameParam="name"
                valueParam="name"
                onSearch={value => {
                  setSearchCity(value)
                }}
                onChange={(_, { option }) => {
                  setSelectedCity(option)
                  settingsForm.setFieldsValue({ instituteCity: option?.name })
                }}
                onClear={() => {
                  setSearchCity('')
                  setSelectedCity({})
                }}
                filterOption={false}
                disabled={!selectedState?._id}
                notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Zipcode*</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Enter Zipcode"
              width="40%"
              name="instituteZipcode"
              type={'number'}
              rules={[
                {
                  validator: (_, value) => {
                    if (value >= 100000 && value <= 999999) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(
                        new Error('Please Enter Valid Zipcode')
                      )
                    }
                  },
                },
              ]}
            />
          </RightSection>
        </CommonFlex>
      </MainWrapper>

      <Divider />

      <MainWrapper marginBottom="100px">
        <ComanyDiv>Contact Info</ComanyDiv>

        <CommonFlex spaceBetween>
          <SubTitleDiv>Contact Person name</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Enter Name"
              width="100%"
              name="contactPersonName"
              maxLength={120}
              rules={[
                {
                  min: 3,
                  max: 120,
                  message: 'Please Enter Valid Name',
                },
              ]}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Contact Person Role</SubTitleDiv>
          <RightSection>
            <FormItem name="contactPersonRole">
              <Select
                showSearch
                allowClear
                placeholder="Select Role"
                OptionData={userRoles}
                nameParam="name"
                valueParam="name"
                isKey={true}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Institute Phone Number*</SubTitleDiv>
          <RightSection>
            <Control>
              <StyledSelectDiv>
                <FormItem name="countryCode">
                  <Select
                    width="100%"
                    placeholder="91"
                    OptionData={CountryCode}
                    nameParam="name"
                    valueParam="value"
                    bordered={false}
                  />
                </FormItem>
              </StyledSelectDiv>
              <StyledInputDiv>
                <StyledInput
                  width="100%"
                  type="number"
                  placeholder="Eg: 1010101010"
                  name="institutePhone"
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter phone number!',
                    },
                    {
                      min: 10,
                      max: 10,
                      message: 'Please enter valid phone number',
                    },
                  ]}
                />
              </StyledInputDiv>
            </Control>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Institute Email Id*</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Enter Email ID"
              width="100%"
              name="instituteEmail"
              rules={[
                () => ({
                  validator(_, value) {
                    let isValid = IsValidEmail(value)
                    if (!isValid) {
                      return Promise.reject(
                        new Error(`Please Enter Valid Email`)
                      )
                    }

                    return Promise.resolve()
                  },
                }),
              ]}
            />
          </RightSection>
        </CommonFlex>
      </MainWrapper>
    </>
  )
}

export default InstituteInfo
